module.exports = __webpack_public_path__ + "vu.c047f3c06d1217a578c7.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/vu.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/vu.svg
// module chunks = styles